import {
  deriveFullAddressFromPropertyKeys,
  isPropertyAgentListing,
  requiresStreetNumberOverrideForProperty,
} from "../utils";

/**
 * Get row customization for a single property listing
 * Returns all agent/area-specific overrides and flags
 */
export function getRowCustomization(list, listgenUserID, mlsAreaID, isCountryClubGate) {

  // Create a copy to avoid mutating original
  const processedList = { ...list };
  // Agent listing detection
  let isAgentListing = isPropertyAgentListing(list);


  // For override statuses, show street number only when _isShowStreetNumber === true.
  const shouldHideStreetNumber =
    requiresStreetNumberOverrideForProperty(list) &&
    list?._isShowStreetNumber !== true;
  const addressForDisplay = {
    ...list,
    streetNumber: shouldHideStreetNumber ? null : list?.streetNumber,
  };
  const addressName = deriveFullAddressFromPropertyKeys(addressForDisplay);
  processedList.address = addressName;


  // Row-level off-market disclaimer/star: only when THIS property is off market.
  let offMarketDisclaimer = list?.isOffMarketSaleBool === true;
  if (TEST_DISCLAIMERS.offMarketDisclaimer) offMarketDisclaimer = true;

  let coListingDiscliamer = false;
  if (TEST_DISCLAIMERS.coListingDiscliamer) coListingDiscliamer = true;

  // Special cases


  const useDaysOnMarketDash = false;
  const useComingSoon = false;
  const addressSize = addressName.length > 25 ? "smaller-row-address" : "";

  // Sale price override
  let salePriceOverride = null;


  return {
    processedList,
    isAgentListing,
    addressSize,
    offMarketDisclaimer,
    coListingDiscliamer,
    useDaysOnMarketDash,
    useComingSoon
  };
}

/**
 * For testing: set any to true to force that disclaimer on for all rows.
 * Change one at a time to test each disclaimer.
 */
export const TEST_DISCLAIMERS = {
  offMarketDisclaimer: false,//* Sold private market disclaimer. hasOffMarketDisclaimer
  coListingDiscliamer: false,//*CL: Co-Listed not required any more. table level also.  remove this
};
/**
 * 
isOffMarketSaleBool is true means * and Sold private market disclaimer disclaimer will come.. individual and tablel level (any one)
: 
null
 */